import { Controller } from "@hotwired/stimulus"

import { repeatedIndexes } from "../progressive_list/repeated"

// The progressive news feed of `doc/pagination.md` 3. Turbo does the loading:
// every page of the feed is a `<turbo-frame>` whose "Показать ещё" link targets
// the next page's frame, so the next page arrives inside the list, after the
// cards already there, and without JavaScript the same link is an ordinary
// page. This controller only removes a card the feed already shows
// (`repeatedIndexes`), which an offset page repeats when a post is published
// between two presses.
export default class ProgressiveListController extends Controller<HTMLElement> {
  dedupe(): void {
    const items = Array.from(this.element.querySelectorAll<HTMLElement>("[data-record-id]"))
    const ids = items.map((item) => item.dataset.recordId ?? "")

    repeatedIndexes(ids).forEach((index) => items[index]?.remove())
  }
}
